// SHARE 클라이언트 동작 한 곳 — ShareDock(RX) · ShareFab(Q4) 가 같이 쓴다(중복 구현 금지).
//  · readyKakao: Kakao SDK + NEXT_PUBLIC_KAKAO_JS_KEY 가 «둘 다 있을 때만» 준비된 객체. 없으면 null(호출부는 카카오 항목을 미렌더).
//  · sendKakaoFeed: feed 템플릿 1종(ShareDock 원래 모양 그대로).
//  · copyText: clipboard → execCommand 폴백. 성공 여부만 돌려준다(안내 문구는 호출부).
// 브라우저 전용 — 서버에서 부르면 null/false.

import { shareDescription } from '@/lib/rx/share';

export const KAKAO_KEY = process.env.NEXT_PUBLIC_KAKAO_JS_KEY;

export type KakaoLike = { isInitialized: () => boolean; init: (k: string) => void; Share?: { sendDefault: (o: unknown) => void } };

export function readyKakao(): KakaoLike | null {
  try {
    const k = (window as unknown as { Kakao?: KakaoLike }).Kakao;
    if (!k || !KAKAO_KEY) return null;
    if (!k.isInitialized()) k.init(KAKAO_KEY);
    return k.isInitialized() && k.Share ? k : null;
  } catch { return null; }
}

/** SDK 는 afterInteractive 로 늦게 온다 — 최대 ~6초(300ms × 20) 기다렸다가 준비되면 onReady. 반환 = 정리 함수. */
export function waitKakao(onReady: () => void): () => void {
  if (!KAKAO_KEY) return () => {};
  if (readyKakao()) { onReady(); return () => {}; }
  let n = 0;
  const iv = setInterval(() => {
    n += 1;
    if (readyKakao()) { onReady(); clearInterval(iv); } else if (n >= 20) clearInterval(iv);
  }, 300);
  return () => clearInterval(iv);
}

export function sendKakaoFeed(o: { url: string; linkUrl: string; title: string; description?: string | null; imageUrl?: string | null }): boolean {
  const k = readyKakao();
  if (!k) return false;
  try {
    const img = o.imageUrl || `${new URL(o.url).origin}/api/og?title=${encodeURIComponent(o.title)}&design=2`;
    k.Share!.sendDefault({
      objectType: 'feed',
      content: { title: o.title, description: shareDescription(o.description), imageUrl: img, link: { mobileWebUrl: o.linkUrl, webUrl: o.linkUrl } },
      buttons: [{ title: '카더라에서 보기', link: { mobileWebUrl: o.linkUrl, webUrl: o.linkUrl } }],
    });
    return true;
  } catch { return false; }
}

export async function copyText(text: string): Promise<boolean> {
  try { await navigator.clipboard.writeText(text); return true; } catch { /* 폴백 */ }
  try {
    const ta = document.createElement('textarea');
    ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
    document.body.appendChild(ta); ta.select();
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    return ok;
  } catch { return false; }
}
